import { FaChartBar, FaInfoCircle } from "react-icons/fa"
import { toast } from "react-toastify"
import { useEffect, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import { getCurrentMonth } from "../utils/GetDates"
import React from "react"
import { GetDynamicColor } from "../utils/GetTextColor"
import ItemRowDasboardLeadDia from "../components/dasboardLeads/ItemRowDasboardLeadDia"
import Tooltip from "../components/ui/ToolTip"



const DasboardLeadsDia = () => {

  const [loadingStatus, setLoadingStatus] = useState(false);

  const [events, setEvents] = useState({});
  const [sellers, setSellers] = useState([]);
  const [workerKPIs, setWorkerKPIs] = useState({});
  const [valoresKPIs, setValoresKPIs] = useState([]);

  const { start, end } = getCurrentMonth()
  const [startDate, setStartDate] = useState(start)
  const [endDate, setEndDate] = useState(end)
  const [selectedSeller, setSelectedSeller] = useState("")

  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [eventType, setEventType] = useState("")
  const [eventSubType, setEventSubType] = useState("")

  const ColorMapKPIs = [
    { min: 0, max: 25, color: "text-red-500" },
    { min: 25, max: 50, color: "text-yellow-400" },
    { min: 50, max: 75, color: "text-green-500" },
    { min: 75, max: 1000, color: "text-blue-500" }
  ];

  const getSellers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[area][equals]=Comercial&where[activo][equals]=true`);
      setSellers(response.data.docs);
    } catch (e) {
      console.error(e);
    }
  };

  const getEvents = async () => {
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/eventosLeads?limit=0`

      let andFilters = [];

      if (eventType) {
        url += `&where[eventType][equals]=${eventType}`
      }

      if (eventSubType) {
        url += `&where[eventSubType][equals]=${eventSubType}`
      }

      if (selectedSeller) {
        url += `&where[seller][equals]=${selectedSeller}`
      }

      if (startDate) {
        const adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
    
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }

      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }

      const response = await axios.get(url)

      // Agrupar eventos por día y luego por trabajador
      const groupedEvents = {};
      
      response.data.docs.forEach(event => {
        // Ajustar la fecha al horario GMT-5
        const eventDate = new Date(event.createdAt);
        const originalDate = eventDate.toISOString().split('T')[0];
        eventDate.setHours(eventDate.getHours() - 5);
        const adjustedDate = eventDate.toISOString().split('T')[0];
        
        // Usar la fecha ajustada solo si no cambia el día
        const date = originalDate === adjustedDate ? originalDate : adjustedDate;
        
        // Crear objeto para el día si no existe
        if (!groupedEvents[date]) {
          groupedEvents[date] = {};
        }

        // Obtener el ID del trabajador del evento
        const workerId = event.seller?.id || 'unknown';
        
        // Crear array para el trabajador si no existe en ese día
        if (!groupedEvents[date][workerId]) {
          groupedEvents[date][workerId] = {
            worker: event.seller,
            events: []
          };
        }
        
        // Agregar el evento al array del trabajador
        groupedEvents[date][workerId].events.push(event);
      });

      //console.log(groupedEvents)
      setEvents(groupedEvents);
      
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
    } catch (e) {
      toast.error(e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getKPIs = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/reglasValoresKPIs?limit=0`);
      setValoresKPIs(response.data.docs);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getSellers();
    getKPIs();
  }, []);

  useEffect(() => {
    if (events && valoresKPIs.length > 0) {
      // Calcular KPIs por trabajador
      const kpisPorTrabajador = {};
      
      Object.values(events).forEach(dayEvents => {
        Object.entries(dayEvents).forEach(([workerId, workerData]) => {
          if (!kpisPorTrabajador[workerId]) {
            kpisPorTrabajador[workerId] = 0;
          }

          const kpi = workerData.events.reduce((acc, event) => {
            const kpiValue = valoresKPIs.find(kpi => kpi.subestado === event.eventSubType)?.valor || 0;
            return acc + kpiValue;
          }, 0);

          kpisPorTrabajador[workerId] += kpi;
        });
      });

      setWorkerKPIs(kpisPorTrabajador);
    }
  }, [events, valoresKPIs]);

  const valorPerdidaLead = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada perdida')?.valor || 0
  const valorLlamadaCorta = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada corta')?.valor || 0
  const valorLlamadaFria = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada fria')?.valor || 0
  const valorLlamadaAtendida = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada atendida')?.valor || 0
  const valorMeetCancelado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet cancelado')?.valor || 0
  const valorMeetReagendado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet reagendado')?.valor || 0
  const valorMeetAgendado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet agendado')?.valor || 0
  const valorMeetAtendido = valoresKPIs.find((kpi) => kpi.subestado === 'Meet atendido')?.valor || 0
  const valorExito = valoresKPIs.find((kpi) => kpi.subestado === 'Exito')?.valor || 0
  const valorEvaluandoOpciones = valoresKPIs.find((kpi) => kpi.subestado === 'Evaluando opciones')?.valor || 0
  const valorParaElFuturo = valoresKPIs.find((kpi) => kpi.subestado === 'Para el futuro')?.valor || 0
  const valorFrio = valoresKPIs.find((kpi) => kpi.subestado === 'Frio')?.valor || 0
  const valorPorConfirmarDeposito = valoresKPIs.find((kpi) => kpi.subestado === 'Por confirmar depósito')?.valor || 0
  const valorCurioso = valoresKPIs.find((kpi) => kpi.subestado === 'Curioso')?.valor || 0
  const valorNoResponde = valoresKPIs.find((kpi) => kpi.subestado === 'No responde')?.valor || 0
  const valorElServicioLePareceCaro = valoresKPIs.find((kpi) => kpi.subestado === 'El servicio le parece caro')?.valor || 0
  const valorDecidióTrabajarConOtraAgencia = valoresKPIs.find((kpi) => kpi.subestado === 'Decidió trabajar con otra agencia')?.valor || 0
  const valorDecidióTrabajarConUnFreelancer = valoresKPIs.find((kpi) => kpi.subestado === 'Decidió trabajar con un freelancer')?.valor || 0
  const valorNoEstaEnMiCiudad = valoresKPIs.find((kpi) => kpi.subestado === 'No esta en mi ciudad')?.valor || 0
  const valorCompetenciaOsospechoso = valoresKPIs.find((kpi) => kpi.subestado === 'Competencia o sospechoso')?.valor || 0
  const valorLeadConPocoPresupuesto = valoresKPIs.find((kpi) => kpi.subestado === 'Lead con poco presupuesto')?.valor || 0

  useEffect(() => {
    getEvents()
  }, [startDate, endDate, eventType, eventSubType, selectedSeller])

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto">
          <div className="flex items-center gap-4 py-4">
            <FaChartBar className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Tabla comparativa de leads</h2>
          </div>
        </div>
      </div>

      {/* Resumen de KPIs por trabajador */}
      <div className="flex flex-col bg-gray-100 mt-0.5 w-full gap-2 px-8 py-2">
        <div className="flex flex-row justify-between w-full items-center gap-4">
          <div className="flex flex-row items-center gap-4">
            {sellers.map(seller => (
              <span key={seller.id} className="flex items-center gap-2">
                <span className="text-xs text-gray-700">{seller.name}:</span>
                <span className={`text-xs font-bold ${GetDynamicColor(workerKPIs[seller.id] || 0, ColorMapKPIs)}`}>
                  {(workerKPIs[seller.id] || 0).toFixed(1)}
                </span>
              </span>
            ))}
          </div>
          <div className="flex flex-row items-center gap-4">
            <span className="text-xs font-bold text-gray-700">
              Puntaje global: <span className="text-gray-700">{Object.values(workerKPIs).reduce((acc, curr) => acc + curr, 0).toFixed(1)} pts</span>
            </span>
          </div>
        </div>
      </div>

      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between w-full gap-10">
        <div className="flex flex-row w-full justify-between overflow-x-auto gap-4 px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row items-center justify-between gap-4 px-4">

            {/* Fechas */}
            <div className="flex flex-row gap-4 items-center justify-start w-full px-4">

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha inicio
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(startDate).toISOString().split('T')[0]}
                    onChange={(e) => setStartDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha fin
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(endDate).toISOString().split('T')[0]}
                    onChange={(e) => setEndDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

            </div>  

            {/* Vendedor */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="text-xs truncate font-semibold">Vendedor:</span>
              <select
                value={selectedSeller}
                onChange={(e) => setSelectedSeller(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                {sellers.map(seller => (
                  <option key={seller.id} value={seller.id}>{seller.name}</option>
                ))}
              </select>
            </div>

            {/* Tipo evento */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="text-xs truncate font-semibold">Tipo evento:</span>
              <select
                value={eventType}
                onChange={(e) => setEventType(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                <option value="Entrada al sistema">Entrada al sistema</option>
                <option value="Llamada">Llamada</option>
                <option value="Google Meet">Google Meet</option>
                <option value="Cambio estado cotización">Cambio estado cotización</option>
              </select>
            </div>

            {/* Subtipo evento */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="text-xs truncate font-semibold">Subtipo evento:</span>
              <select
                value={eventSubType}
                onChange={(e) => setEventSubType(e.target.value)}
                className="text-gray-700 min-w-[200px] hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                {eventType === "Entrada al sistema" && (
                  <option value="Entrada al sistema">Entrada al sistema</option>
                )}
                {eventType === "Llamada" && (
                  <>
                    <option value="Llamada perdida">Llamada perdida</option>
                    <option value="Llamada corta">Llamada corta</option>
                    <option value="Llamada fria">Llamada fria</option>
                    <option value="Llamada atendida">Llamada atendida</option>
                  </>
                )}
                {eventType === "Google Meet" && (
                  <>
                    <option value="Meet cancelado">Meet cancelado</option>
                    <option value="Meet reagendado">Meet reagendado</option>
                    <option value="Meet agendado">Meet agendado</option>
                    <option value="Meet atendido">Meet atendido</option>
                  </>
                )}
                {eventType === "Cambio estado cotización" && (
                  <>
                    <option value="Exito">Exito</option>
                    <option value="Evaluando opciones">Evaluando opciones</option>
                    <option value="Para el futuro">Para el futuro</option>
                    <option value="Frio">Frio</option>
                    <option value="Por confirmar depósito">Por confirmar depósito</option>
                    <option value="Curioso">Curioso</option>
                    <option value="No responde">No responde</option>
                    <option value="El servicio le parece caro">El servicio le parece caro</option>
                    <option value="Decidió trabajar con otra agencia">Decidió trabajar con otra agencia</option>
                    <option value="Decidió trabajar con un freelancer">Decidió trabajar con un freelancer</option>
                    <option value="No esta en mi ciudad">No esta en mi ciudad</option>
                    <option value="Competencia o sospechoso">Competencia o sospechoso</option>
                    <option value="Lead con poco presupuesto">Lead con poco presupuesto</option>
                  </>
                )}
              </select>
            </div>

          </div>
          <div className="flex flex-row items-center justify-center gap-4 px-4">
            <span className="text-xs font-bold text-gray-700">
              {/* Total eventos: <span className="text-gray-700">{leadEvents.length}</span> */}
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
        ) : (
          Object.keys(events).length === 0 ? (
            <NoDataScreen />
          ) : (
            <div className="w-full">
              <table className="w-full text-xs">
                <thead className="text-xs sticky top-0 z-50 text-gray-900 bg-gray-200">
                  <tr className="text-gray-700 text-center text-[10px] font-bold">
                    <td className="px-2 py-3 text-center sticky left-0 bg-[#FE6400] border-r border-r-white text-white border-red">
                      Vendedor
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Número de <span className="truncate">nuevos leads 
                        <Tooltip content="Número de leads procedentes de Kommo.">
                          <div className="inline-block ml-1 hover:cursor-pointer">
                            <FaInfoCircle className="inline-block ml-1" />
                          </div>
                        </Tooltip>
                      </span>
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Tasa <span className="truncate">cierre cot.</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      % Tasa cierre cot. individual
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Tasa <span className="truncate">cierre venta</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      % Tasa <span className="truncate">cierre venta </span>{"\n"}individual
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] text-white">
                      Puntaje <span className="truncate block">total (KPI)</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                      Llamadas perdidas <span className="truncate">(-40 secs)</span>{"\n"}<span className="truncate"> {valorPerdidaLead} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                      Llamadas cortas <span className="truncate">(40-70 secs)</span>{"\n"}<span className="truncate">{valorLlamadaCorta} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                      Llamadas frias <span className="truncate">(70-300 secs)</span>{"\n"}<span className="truncate">{valorLlamadaFria} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                      Llamadas atendidas <span className="truncate">(+300 secs)</span>{"\n"}<span className="truncate">{valorLlamadaAtendida} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-black border-r border-r-white text-white border-red">
                      Total llamadas
                    </td>
                    <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                      Meet Agendados<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetAgendado} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                      Meet Atendidos<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetAtendido} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                      Meet Reagendados<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetReagendado} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                      Meet Cancelados<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetCancelado} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-black border-r border-r-white text-white border-red">
                      Total Google Meet
                    </td>
                    <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                      Cotizaciones<span className="truncate block">frio</span>{"\n"}<span className="truncate block">{valorFrio} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                      Cotizaciones<span className="truncate block">evaluando </span>opciones{"\n"}<span className="truncate block">{valorEvaluandoOpciones} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">por confirmar</span>depósito{"\n"}<span className="truncate block">{valorPorConfirmarDeposito} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                      Cotizaciones para<span className="truncate block"> el futuro</span>{"\n"}<span className="truncate block">{valorParaElFuturo} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">curioso</span>{"\n"}<span className="truncate block">{valorCurioso} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">no responde</span>{"\n"}<span className="truncate block">{valorNoResponde} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">no esta en</span>  mi ciudad{"\n"}<span className="truncate block">{valorNoEstaEnMiCiudad} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">lead con poco</span><span className="truncate block">presupuesto</span>{"\n"}<span className="truncate block">{valorLeadConPocoPresupuesto} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">el servicio le </span>parece caro {"\n"}<span className="truncate block">{valorElServicioLePareceCaro} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">decidió trabajar</span>{"\n"} <span className="truncate block">con otra agencia</span>{"\n"}<span className="truncate block">{valorDecidióTrabajarConOtraAgencia} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">decidió trabajar</span>{"\n"} <span className="truncate block">con un freelancer</span>{"\n"}<span className="truncate block">{valorDecidióTrabajarConUnFreelancer} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                      Cotizaciones <span className="truncate block">competencia o </span>{"\n"} <span className="truncate block">sospechoso</span>{"\n"}<span className="truncate block">{valorCompetenciaOsospechoso} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red sticky right-[120px] z-10">
                      Venta realizada con éxito <span className="truncate block">{valorExito} pts</span>
                    </td>
                    <td className="px-2 py-3 text-center bg-purple-500 border-r border-r-white text-white border-red sticky right-0 z-10 min-w-[120px]">
                      Ventas proyectadas
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(events)
                    .sort((a, b) => new Date(b) - new Date(a))
                    .map(date => {
                      return (
                        <ItemRowDasboardLeadDia
                          key={date}
                          date={date}
                          events={events}
                          valoresKPIs={valoresKPIs}
                        />
                      )
                    })}
                </tbody>
              </table>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default DasboardLeadsDia;